/**
 * Minimal environment-aware logger.
 *
 * Rules:
 *  - `logger.warn` / `logger.error` fire in ALL environments (they signal
 *    something we genuinely want to hear about).
 *  - `logger.debug` and `logger.info` only fire in development so production
 *    consoles stay clean.
 *
 * Prefer this over bare `console.*` in the app code — the code-review linter
 * flags plain console statements as debug leftovers.
 */
const isDev = process.env.NODE_ENV !== "production";

export const logger = {
  debug: (...args) => { if (isDev) console.debug("[app]", ...args); },
  info:  (...args) => { if (isDev) console.info("[app]", ...args); },
  warn:  (...args) => { console.warn("[app]", ...args); },
  error: (...args) => { console.error("[app]", ...args); },
};

export default logger;
